import { FolderContent } from '@/api/generatedApi';
import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { serializeFilterModel } from '@/utils/columnFilterSerializer';
import { GridApiPro, GridFilterModel } from '@mui/x-data-grid-pro';
import { useCallback, useEffect } from 'react';
import { useBulkSelection } from './useBulkSelection';

type FetchFolderContents = (parameters: {
  page: number;
  perPage: number;
}) => Promise<{ contents: FolderContent[]; pageData: { total: number } }>;

export const useFolderBulkSelection = ({
  fetchContents,
  filterModel,
  gridApi,
}: {
  fetchContents: FetchFolderContents;
  filterModel: GridFilterModel;
  gridApi: React.RefObject<GridApiPro | null | undefined>;
}) => {
  const fetchFilteredContents = useCallback(
    (parameters: { page: number; perPage: number }) =>
      fetchContents({ ...parameters, filters: serializeFilterModel(filterModel) } as { page: number; perPage: number }),
    [fetchContents, filterModel]
  );

  const bulkSelection = useBulkSelection<FolderContent, { contents: FolderContent[] }>({
    fetchContents: fetchFilteredContents,
    dataKey: 'contents',
    pageSize: DATA_GRID_LAZY_PAGE_SIZE,
    gridApi,
    selectAllAcrossPages: true,
  });

  const filterKey = JSON.stringify(filterModel);
  useEffect(() => {
    bulkSelection.clearSelection();
  }, [filterKey]);

  return bulkSelection;
};
